import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import Forside from "./pages/Forside";
import Loppeting from "./pages/Loppeting";
import KategoriSide from "./pages/KategoriSide";
import ButikkensPersonale from "./pages/ButikkensPersonale";
import ButikkensHistorie from "./pages/ButikkensHistorie";
import Kontakt from "./pages/Kontakt";
import Error404 from "./pages/Error404";
import Error403 from "./pages/Error403";

export default function App() {
  return (
    <>
      <ScrollToTop />
      <div className="flex min-h-screen flex-col bg-warm-white text-dark-graphite antialiased">
        {/* Header Navigation */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Forside />} />
            <Route path="/personale" element={<ButikkensPersonale />} />
            <Route path="/historie" element={<ButikkensHistorie />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/kategorier" element={<Loppeting />} />
            <Route path="/kategorier/:categorySlug" element={<KategoriSide />} />
            <Route path="/loppeting" element={<Loppeting />} />
            <Route path="/loppeting/:categorySlug" element={<KategoriSide />} />
            <Route path="/:categorySlug" element={<KategoriSide />} />
            <Route path="/403" element={<Error403 />} />
            <Route path="*" element={<Error404 />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
}
